import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import { Typography } from 'antd';
const { Text, Paragraph } = Typography;

 const ActivityGraph = () => {
  const data = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      amt: 2400
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      amt: 2290
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181
    },
    {
      name: "Jun",
      uv: 2390,
      pv: 3800,
      amt: 2500
    },
    {
      name: "Jul",
      uv: 3490,
      pv: 4300,
      amt: 2100
    },
    {
      name: "Aug",
      uv: 4000,
      pv: 2400,
      amt: 2400
    },
    {
      name: "Sep",
      uv: 4000,
      pv: 2400,
      amt: 2400
    },
    {
      name: "Oct",
      uv: 4000,
      pv: 2400,
      amt: 2400
    },
    {
      name: "Nov",
      uv: 4000,
      pv: 2400,
      amt: 2400
    },
    {
      name: "Dec",
      uv: 4000,
      pv: 2400,
      amt: 2400
    }
  ];
  return (
    <div className="activity-graph ">
      <Text className="activity-graph-header">Activity graph</Text>
      <ResponsiveContainer width='100%' height='90%'>
        <LineChart data={data}>
          <CartesianGrid vertical={false} strokeDasharray="3 3" />
          <XAxis axisLine={false} tickLine={false} dataKey="name" padding={{ left: 30, right: 30, }} dy={10} stroke="#86919F"/>
          <YAxis axisLine={false} tickLine={false} stroke="#86919F"/>
          <Tooltip />
          <Line
            strokeWidth='4px'
            type="monotone"
            dataKey="pv"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>  
    </div>  
  );
}

export default ActivityGraph;